import * as THREE from 'three';
import { laneAt, type LaneRoute, type RoutePoint } from '@orb/sim';

export { buildEnemyRoutes, emergenceAt, type LaneRoute } from '@orb/sim';

const _r: RoutePoint = { x: 0, z: 0, dx: 0, dz: 0 };

/** Render-side sampling into three.js vectors: position (feet) and unit direction on a lane. */
export function routeAt(routes: LaneRoute[], lane: number, s: number, out: THREE.Vector3, direction: THREE.Vector3, laneZ?: number) {
  laneAt(routes, lane, s, _r, laneZ);
  out.set(_r.x, 0, _r.z);
  return direction.set(_r.dx, 0, _r.dz);
}
